import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { IS_CAMPAIGN_LANDING_PAGE } from '../../../../constants/commonConstants';
import PMKitCTA from '../../../../components/common/PMKit/PMKitCTA';
import { FLEX_ALIGNMENT } from '../constants';
import cpStyles from './PMKitWidgetCTA.scss';
import useEquipmentDrawer from '@app/hooks/useEquipmentDrawer';

const PMKitWidgetCTA = ({ widgetProps }) => {
  const selectedEquipment = useSelector(
    s => s.myEquipment.equipments.selectedEquipment
  );
  const myEquipmentList = useSelector(
    s => s.myEquipment.equipments.myEquipmentList
  );
  const { openAddDrawer, openEditDrawer, getDrawerComponent } =
    useEquipmentDrawer();
  return (
    <>
      <div
        className={`d-flex p-3 w-sm-100 ${cpStyles['PM-Kit-widget-container']}`}
        style={{
          justifyContent:
            FLEX_ALIGNMENT[widgetProps.widgetAlignment] || 'center',
          width: widgetProps.width
        }}
      >
        <div className={`w-100`}>
          <PMKitCTA
            selectedEquipment={selectedEquipment}
            myEquipmentList={myEquipmentList}
            isCampaignLandingPage={IS_CAMPAIGN_LANDING_PAGE}
            openAddDrawer={openAddDrawer}
            openEditDrawer={openEditDrawer}
          />
        </div>
      </div>
      {getDrawerComponent({ currentEquipment: selectedEquipment })}
    </>
  );
};

PMKitWidgetCTA.propTypes = {
  widgetProps: PropTypes.shape({
    width: PropTypes.string,
    widgetAlignment: PropTypes.string
  })
};

export default PMKitWidgetCTA;
